import { UAParser } from 'ua-parser-js';
const useDeviceInfo = () => {
    let ua = navigator.userAgent || '';
    const device = new UAParser(ua || '').getDevice();
    return {device}
}
export default useDeviceInfo;